import Input from '@/components/base/Input';
import FileDrop from '@/components/base/FileDrop';
import type { RegisterData } from '@/pages/auth/register/types';

interface StepBasicsProps {
  data: RegisterData;
  errors: Partial<Record<keyof RegisterData, string>>;
  update: (key: keyof RegisterData, value: string) => void;
}

export default function StepBasics({ data, errors, update }: StepBasicsProps) {
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <Input
          label="اسم المغسلة"
          name="name"
          icon="ri-store-2-line"
          placeholder="مثال: مغسلة اللمسة النظيفة"
          value={data.name}
          error={errors.name}
          onChange={(event) => update('name', event.target.value)}
        />
        <Input
          label="رقم هاتف التواصل"
          name="phone"
          type="tel"
          icon="ri-phone-line"
          placeholder="05xxxxxxxx"
          value={data.phone}
          error={errors.phone}
          onChange={(event) => update('phone', event.target.value)}
        />
      </div>

      <div className="w-full">
        <label
          htmlFor="reg_description"
          className="mb-2 block font-medium text-[13px] text-foreground-800"
        >
          وصف مختصر
        </label>
        <textarea
          id="reg_description"
          name="description"
          rows={3}
          maxLength={500}
          placeholder="اكتب وصفاً مختصراً يوضح خدمات المغسلة وميزاتها"
          value={data.description}
          onChange={(event) => update('description', event.target.value)}
          className="w-full resize-none rounded-field border border-background-300 bg-white px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 transition-colors focus:border-secondary-400 focus:outline-none focus:ring-2 focus:ring-secondary-100"
        ></textarea>
        <p className="mt-1 text-left text-[11px] text-foreground-400">
          {data.description.length}/500
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <Input
          label="البريد الإلكتروني"
          name="email"
          type="email"
          icon="ri-mail-line"
          placeholder="example@mail.com"
          value={data.email}
          error={errors.email}
          onChange={(event) => update('email', event.target.value)}
        />
        <FileDrop
          label="شعار المغسلة"
          hint="PNG أو JPG مربّع — بحد أقصى 5 ميجابايت"
          fileName={data.logoName}
          onSelect={(fileName) => update('logoName', fileName)}
        />
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <Input
          label="كلمة المرور"
          name="password"
          type="password"
          icon="ri-lock-line"
          placeholder="6 أحرف على الأقل"
          value={data.password}
          error={errors.password}
          onChange={(event) => update('password', event.target.value)}
        />
        <Input
          label="تأكيد كلمة المرور"
          name="confirmPassword"
          type="password"
          icon="ri-lock-2-line"
          placeholder="أعد كتابة كلمة المرور"
          value={data.confirmPassword}
          error={errors.confirmPassword}
          onChange={(event) => update('confirmPassword', event.target.value)}
        />
      </div>
    </div>
  );
}